export default __webpack_public_path__ + "static/media/head12.44fe9952.svg";